exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".move-in-type[data-v-6159ac0c]{text-align:center}.move-in[data-v-6159ac0c]{text-transform:lowercase;padding:18px 30px}.move-in-primary[data-v-6159ac0c]{margin-right:15px}.move-in-resident[data-v-6159ac0c]{padding:18px 40px}.move-in-begin[data-v-6159ac0c]{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6159ac0c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/residents/MoveInType.vue
// module id = vZSr
// module chunks = 0 1